import {
  ReportTemplate,
  ReportTemplateConfiguration,
  ReportTemplatePage,
  ReportTemplateRegion,
  ReportTemplateRegionType,
} from 'src/dto/report-template';
import {
  defaultTemplate,
  protocolSettingsDefault,
  unitDefaults,
} from 'src/utils/constants/settings.const';
import { DEFAULT_UNIT_SETTINGS } from '@schenck/rotec-components';

export class TemplateFactory {
  public static createBlankReportTemplate(): ReportTemplate {
    let reportTemplate = {} as ReportTemplate;

    reportTemplate.config = TemplateFactory.createConfig();
    reportTemplate.pages = [TemplateFactory.createPage()];
    reportTemplate.userDefinedFields = [];

    return reportTemplate;
  }

  /**
   * Create a template with prefilled Values
   * @see DIG-13883
   * @returns prefilled default template
   */
  public static createDefaultReportTemplate(): Partial<ReportTemplate> {
    return defaultTemplate;
  }

  public static createConfig(): ReportTemplateConfiguration {
    return {
      language: protocolSettingsDefault.protocolLanguage,
      measuringRun: protocolSettingsDefault.measuringRuns,
      numberOfDecimalPlaces: DEFAULT_UNIT_SETTINGS.decimals,
      lengthUnit: unitDefaults.lengthUnit,
      unbalUnit: unitDefaults.unbalUnit,
      weightUnit: unitDefaults.weightUnit,
      isUnbalanceAsMass: DEFAULT_UNIT_SETTINGS.isUnbalanceAsMass,
      rotationUnit: DEFAULT_UNIT_SETTINGS.nominalSpeedValue,
    };
  }

  public static createPage(): ReportTemplatePage {
    return {
      regions: [
        TemplateFactory.createRegion('', ReportTemplateRegionType.Header, 5),
        TemplateFactory.createRegion('', ReportTemplateRegionType.Main, 18),
        TemplateFactory.createRegion('', ReportTemplateRegionType.MeasurementData, 12),
        TemplateFactory.createRegion('', ReportTemplateRegionType.Footer, 3),
      ],
    } as ReportTemplatePage;
  }

  public static createRegion(
    name: string,
    type: ReportTemplateRegionType,
    rows: number
  ): ReportTemplateRegion {
    return {
      name,
      type,
      fields: [],
      rows,
    };
  }
}
